/**
 * LocalStorage Management
 * Handles persistent storage of feature flags
 */

import { FeatureFlag } from './types';
import { DEFAULT_CONFIG } from './constants';

export class FlagStorage {
  private storageKey: string;

  constructor(storageKey: string = DEFAULT_CONFIG.storageKey) {
    this.storageKey = storageKey;
  }

  save(flags: Record<string, FeatureFlag>): void {
    try {
      const serialized = JSON.stringify(flags);
      localStorage.setItem(this.storageKey, serialized);
    } catch (error) {
      console.warn('Failed to save feature flags to localStorage:', error);
    }
  }

  load(): Record<string, FeatureFlag> {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (!stored) return {};
      
      return JSON.parse(stored);
    } catch (error) {
      console.warn('Failed to load feature flags from localStorage:', error);
      return {};
    }
  }

  clear(): void {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (error) {
      console.warn('Failed to clear feature flags from localStorage:', error);
    }
  }

  update(flagName: string, flag: FeatureFlag): void {
    const flags = this.load();
    flags[flagName] = flag;
    this.save(flags);
  }
}

export const flagStorage = new FlagStorage();
